export const AppNames = {
  Physical: "Physical data",
  Financial: "Financial reports",
  SQL: "SQL access",
  Performance: "Performance metrics"
};



// WEBPACK FOOTER //
// ./src/utils/helpers/AppNames.js